import styled from 'styled-components'

export const Flex = styled.div`
  display: flex;
`

export const HomeContainer = styled.div`
  min-height: 100vh;
  margin: 0px;
  overflow-y: auto;
  background-color: ${props => props.bgColor};
  width: 100%;

  @media (max-width: 576px){
    width: 100%;
  }
`

export const Banner = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 200px;
  background-image: url('https://assets.ccbp.in/frontend/react-js/nxt-watch-banner-bg.png');
  background-size: cover;
  padding: 20px 30px;

  @media (max-width: 576px){
    padding: 15px;
  }
`

export const BannerCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`

export const BImg = styled.img`
  width: 120px;
`

export const BText = styled.p`
  color: #212121;
  font-size: 16px;
  width: 350px;
`

export const BBtn = styled.button`
  border: 1px solid #212121;
  background-color: transparent;
  color: #212121;
  font-size: 13px;
  padding: 5px 12px;
  align-self: flex-start;
  margin: 10px 0px;
`

export const Button = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  background-color: transparent;
  align-self: flex-start;
  font-size: 20px;
`

export const HomeSection = styled.div`
  padding: 20px;
  min-height: 100%;

  @media (max-width: 576px){
    padding: 0px;
  }
`

export const SearchCard = styled.div`
  border: 1px solid ${props => props.searchBorder};
  background: ${props => props.searchBg};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 60%;

  @media (max-width: 576px){
    width: 90%;
    margin: 20px;
  }

  @media (max-width: 768px){
    width: 80%;
  }
`

export const Search = styled.input`
  background: transparent;
  border: none;
  outline: none;
  padding: 3px 15px;
  color: ${props => props.searchColor};
  flex: 1;
`

export const SearchBtn = styled.button`
  padding: 6px 18px;
  border: none;
  cursor: pointer;
  background-color: ${props => (props.dark ? '#424242' : '')};
  color: ${props => (props.dark ? 'lightgray' : 'black')};
`

export const HomeCards = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  column-gap: 20px;
  row-gap: 40px;
  margin: 30px 0px;

  @media (max-width: 576px){
    grid-template-columns: auto;
  }

  @media (max-width: 768px){
    grid-template-columns: auto auto;
  }
`

export const NoResults = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  width: 100%;
  background: ${props => props.bg};

  @media (max-width: 768px){
    min-height: 92vh;
  }
`

export const NoRImg = styled.img`
  width: ${props => (props.failure ? '25%' : '30%')};
  margin: 20px;

  @media (max-width: 768px){
    width: 70%;
  }
`

export const NoR = styled.h1`
  color: ${props => props.color};
  font-size: 23px;
`

export const NoRPara = styled.p`
  color: #64748b;
  font-size: 15px;
  text-align: center;
`

export const RetryButton = styled.button`
  color: white;
  border-radius: 4px;
  padding: 10px 25px;
  font-size: 10px;
  font-weight: bold;
  background-color: #4f46e5;
  border: none;
  cursor: pointer;
`
